<div class="container px-0 px-md-3 mt-4"  *ngIf="showstepper">
  <div class="row row-sm-collapsed">
      <div class="col-12">
          <div class="shopping-stepper">
              <div (click)="move(0)" class="step" [ngClass]="{ 'step-current': selectedIndex === 0, 'visited': selectedIndex > 0 }">
                  Betaling</div>
              <div (click)="selectedIndex > 0 && move(1)" class="step"
                  [ngClass]="{ 'step-current': selectedIndex === 1, 'visited': selectedIndex > 1 }">Bekræftelse 
              </div>
              <div (click)="selectedIndex > 1 && move(2)" class="step" [ngClass]="{ 'step-current': selectedIndex === 2 }">Kvittering
              </div>
          </div>
      </div>
  </div>
</div>
